"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var randomId_1 = require("../lib/randomId");
var logOrThrowError_1 = require("../lib/logOrThrowError");
var Item_1 = require("./Item");
var ItemWrapper_1 = require("./ItemWrapper");
var DEFAULT_CLASSPREFIX = 'Accordion';
var DEFAULT_IDPREFIX = 'accordion__';
var Accordion = /** @class */ (function (_super) {
    __extends(Accordion, _super);
    function Accordion(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            selectedItemId: null
        };
        // A map of child components to their IDs.
        _this.idMap = new WeakMap();
        // Child ID -> item button ref map.
        _this.itemRefMap = new Map();
        _this.renderChild = function (child) {
            // istanbul ignore if
            if (child.type !== Item_1.default) {
                logOrThrowError_1.default('Accordion: invalid child provided. Expecting AccordionItem only');
                return;
            }
            // Ensure we update the ID map.
            if (!_this.idMap.has(child)) {
                _this.idMap.set(child, randomId_1.default(_this.props.idPrefix || DEFAULT_IDPREFIX));
            }
            var _a = _this.props.classPrefix, classPrefix = _a === void 0 ? DEFAULT_CLASSPREFIX : _a;
            var _b = child.props, title = _b.title, children = _b.children;
            var childId = _this.idMap.get(child);
            var isOpen = _this.state.selectedItemId === childId;
            return (React.createElement(ItemWrapper_1.default, { classPrefix: classPrefix, onFocusShift: _this.handleFocusShift, title: title, id: childId, onToggle: _this.handleToggleItem, open: isOpen, buttonRef: function (el) {
                    return _this.itemRefMap.set(childId, el);
                } }, children));
        };
        _this.handleToggleItem = function (itemId) {
            if (_this.state.selectedItemId === itemId) {
                _this.setState({ selectedItemId: null });
            }
            else {
                _this.setState({ selectedItemId: itemId });
            }
        };
        _this.handleFocusShift = function (direction, id) {
            var ids = Array.from(_this.itemRefMap.keys());
            var index = ids.indexOf(id);
            var nextIndex = -1;
            if (direction === 'start') {
                nextIndex = 0;
            }
            else if (direction === 'end') {
                nextIndex = ids.length - 1;
            }
            else if (direction === 'backwards') {
                if (index === 0) {
                    nextIndex = ids.length - 1;
                }
                else {
                    nextIndex = index - 1;
                }
            }
            else {
                if (index === ids.length - 1) {
                    nextIndex = 0;
                }
                else {
                    nextIndex = index + 1;
                }
            }
            var nextId = ids[nextIndex];
            var button = _this.itemRefMap.get(nextId);
            if (!button) {
                logOrThrowError_1.default("Accordion: unable to locate button \"" + nextId + "\"");
                return;
            }
            button.focus();
        };
        // Set the initial IDs.
        React.Children.forEach(props.children, function (child) {
            var id = randomId_1.default(props.idPrefix || DEFAULT_IDPREFIX);
            _this.idMap.set(child, id);
        });
        return _this;
    }
    Accordion.prototype.render = function () {
        var _a = this.props, children = _a.children, _b = _a.classPrefix, classPrefix = _b === void 0 ? DEFAULT_CLASSPREFIX : _b, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        idPrefix = _a.idPrefix, props = __rest(_a, ["children", "classPrefix", "idPrefix"]);
        return (React.createElement("div", __assign({ className: classPrefix }, props), React.Children.map(children, this.renderChild)));
    };
    Accordion.displayName = 'Accordion';
    Accordion.propTypes = {
        classPrefix: PropTypes.string,
        idPrefix: PropTypes.string,
        // Validate child component types.
        children: function (props, propName) {
            var children = props[propName];
            var hasInvalidChild = false;
            if (!React.Children.count(children)) {
                return new Error('Accordion expects at least a single AccordionItem child');
            }
            React.Children.forEach(children, function (child) {
                if (child.type !== Item_1.default || !child.props.children) {
                    hasInvalidChild = true;
                    return;
                }
            });
            if (hasInvalidChild) {
                return new Error('Accordion expects children to be of type AccordionItem');
            }
            return null;
        }
    };
    return Accordion;
}(React.Component));
exports.default = Accordion;
//# sourceMappingURL=Accordion.js.map